import { AuditOutlined } from '@ant-design/icons';
import { ComingSoonPage } from '@/components/ComingSoonPage';

export function AuditLogPage() {
  return (
    <ComingSoonPage
      accent="violet"
      icon={<AuditOutlined />}
      title="Audit log"
      subtitle="Platform-wide activity trail"
      helpTopic="audit.overview"
      description="Every change made through AgentStudio is recorded here. Who deployed which agent, who toggled which capability, who edited which procedure. HIPAA-grade audit trail for compliance reviews."
      eta="H2"
      adminOnly
      features={[
        { label: 'Chronological event stream', description: 'Filterable by user, merchant, action type, time range' },
        { label: 'Diff view per change', description: 'Before/after for any edit to skill content, instructions, or settings' },
        { label: 'Export for compliance', description: 'CSV / PDF reports for SOC 2 and HIPAA audits' },
        { label: 'Retention policy', description: '7-year retention with cold storage tier after 90 days' },
        { label: 'Tamper detection', description: 'Hash-chained log entries; any tampering shows up on next read' },
      ]}
    />
  );
}
